import React from "react";
import { Component, Fragment } from "react";
import {
	Progress,
	Card,
	CardBody,
  CardTitle,
	Row,
	Col,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import img1 from '../../../assets/images/background/active-bg.png';
import Moment from 'moment';
import {
	appendProductFilter,
	beginDashboardRequest,
	finishDashboardRequest,
	markDashboardRequestSucceeded,
	getDashboardRefreshWait,
	getStoredProductType,
	ignoreDashboardRequestError,
	isDashboardRequestCurrent,
	scheduleDashboardRetry,
	stopDashboardPolling
} from '../product-filter';
import DashboardCardLoader from '../dashboard-card-loader';
import { formatProcedureName } from './procedure-name';
var moment = require('moment-timezone');

class TopProcedures extends React.Component {

	noResults = true;
	intervalID = 0;

	constructor(props) {
    super(props);
    this.state = {
			rSelected: 3,
			topProcedures: [],
			colors: [{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}],
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(3, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Global",
			tooltipOpen: false,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			ratioRange: 0,
			slidingScale: [500, 1000, 1500],
			totalProceduresLabel: 0,
			marketType: localStorage.getItem('marketType') ? JSON.parse(localStorage.getItem('marketType')) : 0,
			productType: getStoredProductType(),
			isLoading: false
	  };

		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {

		document.body.addEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.addEventListener('set-product-type', this.handleProductTypeChange.bind(this));

		if (this.state.currentUser) {
			this.scheduleDataRefresh();
		} else {
			this.scheduleDataRefresh();
		}
	}

	scheduleDataRefresh(delay, showLoader = true) {
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (showLoader) {
			this.setState({
				isLoading: true,
				totalProceduresLabel: 0
			});
		}
		this.dashboardRefreshTimeout = setTimeout(()=>{ this.getData({ showLoader }); }, delay || getDashboardRefreshWait('topProcedures'));
	}

	handleMarketTypeChange(event) {
		console.log("Top Procedures Market has changed to: ", event.detail);
    // your business logic here .. this.setState({...});
		this.setState({ marketType: event.detail.id });
		this.scheduleDataRefresh();
  }

	handleProductTypeChange(event) {
		console.log("Top Procedures Product has changed to: ", event.detail);
		this.setState({ productType: event.detail.id });
		this.scheduleDataRefresh();
  }

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		}

		this.scheduleDataRefresh();
  }

	handleSubmit(event) {

		this.getData({ showLoader: true });
  }

	selectDropDownItem(id, title) {

		this.setState({ topProcedures: [] });

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		} else if (id==3) {
			this.setState({ startDate: Moment().format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });

		this.scheduleDataRefresh();
  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}
		this.scheduleDataRefresh();
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}
		this.scheduleDataRefresh();
	}

	componentWillUnmount() {
		//console.log("top-procedures componentWillUnmount");
		clearInterval(this.intervalID);
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (this.dashboardAbortController) {
			this.dashboardAbortController.abort();
		}
		document.body.removeEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.removeEventListener('set-product-type', this.handleProductTypeChange.bind(this));
	}

	getData = async (options = {}) => {
		const request = beginDashboardRequest(this, options.showLoader === true);
		if (options.showLoader === true) {
			this.setState({ totalProceduresLabel: 0 });
		}
		const signal = request.controller.signal;

		var timezone = Moment.tz.guess();

		if (this.state.currentDataSetting==0) {

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("top-procedures this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures?MarketType="+this.state.marketType, this.state.productType);

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("topprocedures body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);

					var total = 0;

					body.results.map((prop, key) => {
						total = total + parseInt(prop.total);
					});

					this.setState({ totalProceduresLabel: total });

					if (body.results.length>0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}

						var ratio = 2*largest;

						// var ratio = 0;
						// var i = 1;
						//
						// while (largest>ratio) {
						// 	ratio = i*500;
						// 	i++;
						// }
						// console.log("ratio: " + ratio);

						console.log("topprocedures body response LARGEST: " + largest);
						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: ratio
				    });
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
				} else {

					if (this.state.topProcedures.length>0) {
						this.setState({
							noDataForDevices: false
						});
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

		} else {

			var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures-date-range?MarketType="+this.state.marketType+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone, this.state.productType);

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("top-procedures this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("topprocedures by date body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);

					var total = 0;

					body.results.map((prop, key) => {
						total = total + parseInt(prop.total);
					});

					this.setState({ totalProceduresLabel: total });

					if (body.results.length>0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}

						var ratio = 2*largest;

						// var ratio = 0;
						// var i = 1;
						//
						// while (largest>ratio) {
						// 	ratio = i*500;
						// 	i++;
						// }
						// console.log("ratio: " + ratio);

						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: ratio
				    });
					} else {
						this.setState({
							noDataForDevices: true
				    });
					}
				} else {
					this.setState({
						noDataForDevices: true
					});
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

		}

		finishDashboardRequest(this, request.requestId, () => this.getData({ showLoader: false }));
	}

	getColor(presetID) {

		var color = "success";

		if (presetID>=1 && presetID<=5) {
			color = "success";
		} else if (presetID>=11 && presetID<=19) {
			color = "info";
		} else if (presetID>=21 && presetID<=23) {
			color = "yellow";
		}

		return color;

	}

	render() {

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ minHeight: 650 }}>
					<Row>
						<Col xs="5" lg="5" className="text-left">
							<CardTitle>Top 10 Preset Procedures
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="TopProceduresTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TopProceduresTooltip" toggle={this.toggleTooltip}>
								Shows the most common procedures performed by desired time period, as well as how many times each of these top procedures were performed.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="3" lg="3" className="text-right">
							<h5 className="text-center" style={{color: '#fec007', lineHeight: "1.7"}}>{this.state.totalProceduresLabel}</h5>
						</Col>
						<Col xs="4" lg="4" className="text-right">
							<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
								<DropdownToggle color="dark" caret>
									{this.state.currentItem}
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(1, 'By Week')}>By Week</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(2, 'By Month')}>By Month</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(3, 'Custom Range')}>Custom Range</DropdownItem>
								</DropdownMenu>
							</ButtonDropdown>
						</Col>
					</Row>
					{this.state.noDevices ? (
						<div className="mt-5 text-center">
							<h5>User has no devices</h5>
						</div>
					) : (
						<Fragment>
						{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
							<Fragment>
							<div className="ml-auto mt-1" style={{height: '450px'}}>
									{this.state.isLoading ? (
										<DashboardCardLoader />
									) : this.state.noDataForDevices ? (
										<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
											<h5>No data for user's devices</h5>
										</div>
									) : (
										<div className="pt-1">
											{this.state.topProcedures.map((procedure, i) => (
												<Fragment>
												<Row key={i}>
													<Col xs="3" md="3" lg="3" className="text-left">
														<span>{procedure.total}</span>
													</Col>
													<Col xs="9" md="9" lg="9" className="text-right">
														<span>{formatProcedureName(procedure)}</span>
													</Col>
												</Row>
												<Progress multi className="mt-1 mb-3">
													<Progress bar color={this.getColor(procedure.preset)} value={(procedure.total/this.state.ratioRange)*100} />
												</Progress>
												</Fragment>
											))}
										</div>
									)}
							</div>
							{this.state.currentDataSetting != 0 &&
								<Fragment>
								<Row className="pt-5 mt-5">
									<Col lg="12" xl="6" className="text-right">
										<div className="float-left" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
										</div>
									</Col>
									<Col lg="12" xl="6" className="">
										<div className="float-left text-right" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
										</div>
										{
											// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
											// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go" disabled={this.state.currentDataSetting != 3}>
											// 	GO
											// </Button>
											// </div>
										}
									</Col>
								</Row>
								</Fragment>
							}
							</Fragment>
						) : (
							<Fragment>
							<Row className="align-items-center mt-4" style={{height: '430px'}}>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
									</Button>
								</div>
								<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
									<div className="ml-4 mt-1">
											{this.state.isLoading ? (
												<DashboardCardLoader />
											) : this.state.noDataForDevices ? (
												<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
													<h5>No data for user's devices</h5>
												</div>
											) : (
												<div className="pt-1">
													{this.state.topProcedures.map((procedure, i) => (
														<Fragment>
														<Row key={i}>
															<Col xs="3" md="3" lg="3" className="text-left">
																<span>{procedure.total}</span>
															</Col>
																	<Col xs="9" md="9" lg="9" className="text-right">
																		<span>{formatProcedureName(procedure)}</span>
																	</Col>
														</Row>
														<Progress multi className="mt-1 mb-3">
															<Progress bar color={this.getColor(procedure.preset)} value={(procedure.total/this.state.ratioRange)*100} />
														</Progress>
														</Fragment>
													))}
												</div>
											)}
									</div>
								</div>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
									</Button>
								</div>
							</Row>
							<Row className="pt-5 mt-5">
								<Col lg="12" xl="6" className="text-right">
									<div className="float-left" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
									</div>
								</Col>
								<Col lg="12" xl="6" className="">
									<div className="float-left text-right" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
									</div>
									{
										// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
										// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go">
										// 	GO
										// </Button>
										// </div>
									}
								</Col>
							</Row>
							</Fragment>
						)}
						</Fragment>
					)}
				</CardBody>
			</Card>

		);
	}
}

export default TopProcedures;
